import React, { createContext, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { createMultipleInsights } from '../services/insightsService.js';
import { createInsightsArray } from '../components/ProgramInsights/programInsightsHelpers.js';
import { ToastComponent } from '@tylertech/forge';

export const AiInsightsContext = createContext(null);

const AiInsightsContextProvider = ({ children }) => {
  const [sets, setSets] = useState([]);
  const [currentSet, setCurrentSet] = useState(null);
  const [generatedInsights, setGeneratedInsights] = useState([]);
  const [implementationPlans, setImplementationPlans] = useState([]);
  const [showImplementationPage, setShowImplementationPage] = useState(false);
  const [showAiInsightsCreation, setShowAiInsightsCreation] = useState(false);
  const [openImpactDialog, setOpenImpactDialog] = useState(false);

  const createInsights = useCallback(async (gridRef, showSaveButton) => {
    const predictionSet = sets.find(
      (set) => set.name.toLowerCase() === currentSet?.name.toLowerCase(),
    );
    const insights = createInsightsArray(gridRef, predictionSet);

    await createMultipleInsights({
      setId: predictionSet?.id,
      insights,
    });

    ToastComponent.present({ message: 'Successfully created insights' });

    if (!showSaveButton) gridRef.current?.api?.deselectAll();
  }, [currentSet, sets]);

  const value = useMemo(() => ({
    sets,
    setSets,
    currentSet,
    setCurrentSet,
    generatedInsights,
    setGeneratedInsights,
    implementationPlans,
    setImplementationPlans,
    showImplementationPage,
    setShowImplementationPage,
    showAiInsightsCreation,
    setShowAiInsightsCreation,
    createInsights,
    setOpenImpactDialog,
    openImpactDialog,
  }), [
    sets,
    currentSet,
    generatedInsights,
    implementationPlans,
    showImplementationPage,
    showAiInsightsCreation,
    openImpactDialog,
    createInsights,
  ]);

  return (
    <AiInsightsContext.Provider value={value}>
      {children}
    </AiInsightsContext.Provider>
  );
};

AiInsightsContextProvider.propTypes = {
  children: PropTypes.node,
};

export default AiInsightsContextProvider;
